import axiosClient from "@/libs/axiosClient";

export const downloadCert = (data) => {
    return axiosClient.post(`/download/cert`, data);
};



// WEBPACK FOOTER //
// ./src/api/download.js